import { OriginatorDating, OriginatorEvent, OriginatorReference } from 'types';

export const constructOriginatorEventLabel = (
  event: OriginatorEvent
): string => {
  const formatFrom = event.begin ? `, od: ${event.begin}` : '';
  const formatTo = event.end ? `, do: ${event.end}` : '';
  const formatStudyStatus = event.studyStatusLabel
    ? `, ${event.studyStatusLabel}`
    : '';
  return `${event.typeLabel}${formatFrom}${formatTo}${formatStudyStatus}`;
};

export const constructDatingString = (dating: OriginatorDating): string =>
  `${dating?.methodLabel ?? ''}${
    dating?.date ? `${dating?.methodLabel ? ', ' : ''}${dating?.date}` : ''
  }`;

export const constructRelationLink = (
  relatedEntity: OriginatorReference
): string => `/rejstriky/all/${relatedEntity?.label}/0/10/${relatedEntity?.id}`;
